/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The upstream credential a headless caller's sessions use on one MCP server.
 */
export type IssuanceProfileChoice = {
  /**
   * The auth client. Omit for a server whose upstream needs no authentication.
   */
  authClientId?: string | undefined;
  /**
   * The MCP server.
   */
  mcpServerId: string;
};

/** @internal */
export const IssuanceProfileChoice$inboundSchema: z.ZodMiniType<
  IssuanceProfileChoice,
  unknown
> = z.pipe(
  z.object({
    auth_client_id: z.optional(z.string()),
    mcp_server_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "auth_client_id": "authClientId",
      "mcp_server_id": "mcpServerId",
    });
  }),
);
/** @internal */
export type IssuanceProfileChoice$Outbound = {
  auth_client_id?: string | undefined;
  mcp_server_id: string;
};

/** @internal */
export const IssuanceProfileChoice$outboundSchema: z.ZodMiniType<
  IssuanceProfileChoice$Outbound,
  IssuanceProfileChoice
> = z.pipe(
  z.object({
    authClientId: z.optional(z.string()),
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      authClientId: "auth_client_id",
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function issuanceProfileChoiceToJSON(
  issuanceProfileChoice: IssuanceProfileChoice,
): string {
  return JSON.stringify(
    IssuanceProfileChoice$outboundSchema.parse(issuanceProfileChoice),
  );
}
export function issuanceProfileChoiceFromJSON(
  jsonString: string,
): SafeParseResult<IssuanceProfileChoice, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IssuanceProfileChoice$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IssuanceProfileChoice' from JSON`,
  );
}
